import { render, staticRenderFns } from "./Presskit.vue?vue&type=template&id=623267b6&scoped=true&"
import script from "./Presskit.vue?vue&type=script&lang=js&"
export * from "./Presskit.vue?vue&type=script&lang=js&"
import style0 from "./Presskit.vue?vue&type=style&index=0&id=623267b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623267b6",
  null
  
)

export default component.exports